function menuButtonDivider() {
  return {
    restrict: 'E',
    require: '^^akamMenuButton',
    replace: true,
    template: `<li class="divider"></li>`,
    link(scope, elem, attr, ctrl) {
      // Only here to force akamMenuButtonDivider to live inside akamMenuButton
    }
  };
}

export default menuButtonDivider;
